import React from 'react';
import { useField, useFormikContext } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';
import { Star } from '@phosphor-icons/react';

const stars = [1,2,3,4,5]

export default function RateInput(props) {

    const {
        label,
        name,
        readOnly,
        fieldId,
        onChange,
        center,
        large
    } = props

    const [field, meta] = useField({
        name,
        readOnly,
        id: fieldId || name
    });

    const {setFieldValue} = useFormikContext();

    function onChangeHandler(event, value) {

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }
        
        return setFieldValue(name, value);
    }

    const SizeClasses = large ? 'h-14 w-14' : 'h-5 w-5';

    return (
        <Container checkbox noMargin>
            <div className="input-element-container relative pt-3">
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    relative
                />

                <div className={`flex gap-2 ${center && 'justify-center'}`}>
                    {stars.map((star, index) => {
                        if (star <= field?.value) {
                            return (
                                <Star
                                    className={`cursor-pointer fill-yellow ${SizeClasses}`}
                                    onClick={(e) => onChangeHandler(e, star)}
                                    weight="fill"
                                    key={index}
                                />
                            )
                        }

                        return (
                            <Star
                                className={`cursor-pointer fill-yellow ${SizeClasses} hover:fill-black`}
                                weight="thin"
                                onClick={(e) => onChangeHandler(e, star)}
                                key={index}
                            />
                        )
                    })}
                </div>
            </div>

            {meta?.error && (
                <Error error={meta.error} left/>
            )}
        </Container>
    )
}
